export default class AppUser {

    public id: string;
    public firstname: string;
    public lastname: string;
    public accountNumber: string;
    public username: string;

    constructor(userData: any) {
        this.id = userData._id;
        if (userData.id) {
            this.id = userData.id;
        }
        this.firstname = userData.firstname;
        this.lastname = userData.lastname;
        this.accountNumber = userData.accountNumber;
        this.username = userData.username;
    }
}
